import { useIsDesktop } from './useIsDesktop';
import { useIsDesktopExtraLarge } from './useIsDesktopExtraLarge';
import { useIsDesktopLarge } from './useIsDesktopLarge';
import { useIsTablet } from './useIsTablet';

export type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export const useCurrentBreakpoint = (): Breakpoint => {
  const isTablet = useIsTablet();
  const isDesktop = useIsDesktop();
  const isDesktopLarge = useIsDesktopLarge();
  const isDesktopExtraLarge = useIsDesktopExtraLarge();

  if (isDesktopExtraLarge) return 'xl';
  if (isDesktopLarge) return 'lg';
  if (isDesktop) return 'md';
  if (isTablet) return 'sm';
  return 'xs';
};
